module.exports = __webpack_public_path__ + "assets/images/glasses-03.f369a27a34bef08dfd42c8da4262a916.svg";